import {
  fetchVapidPublicKey,
  getPushClientState,
  getPushOptInPreference,
  isPushSupported,
} from "./pushNotifications";

const DISMISS_KEY = "intrapaf_push_prompt_dismissed";
const DISMISS_DAYS = 7;

export function wasPushPromptDismissed() {
  try {
    const raw = localStorage.getItem(DISMISS_KEY);
    if (!raw) {
      return false;
    }
    const dismissedAt = Number.parseInt(raw, 10);
    if (Number.isNaN(dismissedAt)) {
      return false;
    }
    return Date.now() - dismissedAt < DISMISS_DAYS * 24 * 60 * 60 * 1000;
  } catch (e) {
    return false;
  }
}

export function dismissPushPrompt() {
  try {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
  } catch (e) {
    // ignore
  }
}

export async function shouldOfferPushNotifications(
  apiGet,
  vapidUrl,
  pushEnabled
) {
  if (!isPushSupported()) {
    return false;
  }
  if (pushEnabled || getPushOptInPreference()) {
    return false;
  }
  if (wasPushPromptDismissed()) {
    return false;
  }

  const { permission, hasSubscription } = await getPushClientState();
  if (permission === "denied") {
    return false;
  }
  if (permission === "granted" && hasSubscription) {
    return false;
  }

  const key = await fetchVapidPublicKey(apiGet, vapidUrl);
  return key !== null;
}
